module.exports = __webpack_public_path__ + "static/media/tr.a070cc22.webp";